import React, { useState, useEffect, useRef } from 'react';
import { bool, func, oneOf, shape, string } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import routeConfiguration from '../../routeConfiguration';
import config from '../../config';
import { createResourceLocatorString } from '../../util/routes';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { ensureCurrentUser } from '../../util/data';
import { propTypes } from '../../util/types';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
  stripeAccountClearError,
  getStripeConnectAccountLink,
} from '../../ducks/stripeConnectAccount.duck';
import {
  NamedRedirect,
  // LayoutSideNavigation,
  // LayoutWrapperMain,
  // LayoutWrapperAccountSettingsSideNav,
  // LayoutWrapperTopbar,
  // LayoutWrapperFooter,
  // Page,
  StripeConnectAccountStatusBox,
  // UserNav,
} from '../../components';
import { StripeConnectAccountForm } from '../../forms';
// import { TopbarContainer } from '..';
import { savePayoutDetails, loadData, removeSubscription, reactivateSubscription, fetchPortalSession } from './StripePayoutPage.duck';

import css from './StripePayoutPage.css';

import ContainerWrapper from '../../custom-components/wrappers/container-wrapper/ContainerWrapper';
import PageWrapper from '../../custom-components/wrappers/page-wrapper/PageWrapper';
import Footer from '../../custom-components/elements/footer/Footer';

// import DashboardLayoutWrapper from '../../custom-components/wrappers/dashboard-layout-wrapper/DashboardLayoutWrapper';
// import DashboardPaymentsWrapper from '../../custom-components/wrappers/dashboard-payments-wrapper/DashboardPaymentsWrapper';
import SettingsLayoutWrapper from '../../custom-components/wrappers/settings-layout-wrapper/SettingsLayoutWrapper';
import NavBarWrapper from '../../custom-components/wrappers/navbar-wrapper/NavBarWrapper';
import NavBar from '../../custom-components/elements/nav-bar/NavBar';

import classnames from 'classnames';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import SwitchToggle from '../../custom-components/elements/switch-toggle/SwitchToggle';
import PriceTag from '../../custom-components/elements/price-tag/PriceTag';
// import Button from '../../custom-components/elements/Button/Button';

// import { ProfileSettingsForm } from '../../forms';
// import { PayoutDetailsIndividualAccount } from '../../forms';
// import * as validators from '../../util/validators';
// import { isUploadImageOverLimitError } from '../../util/errors';
// import { Form, Avatar, ImageFromFile, IconSpinner, FieldTextInput } from '../../components';
// import { faLock, faMobile, faUser, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
// import { faPaypal } from '@fortawesome/free-brands-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter } from 'react-router-dom';
// import { createHashHistory } from 'history';
// import { types as sdkTypes } from '../../util/sdkLoader';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';


// import { createSlug } from '../../util/urlHelpers';
//
// import { findRouteByRouteName } from '../../util/routes';

import axios from 'axios';
import { getReferralCode, clearReferralCode } from '../../util/referral';
import { getIntendedPlan, clearIntendedPlan } from '../../util/intendedPlan';
import { fetchCurrentUser } from '../../ducks/user.duck';
import PaymentTable3 from '../../custom-components/elements/payment-table/PaymentTable3';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import ReactTooltip from 'react-tooltip';
import { checkProfileCompleted } from '../../custom-ducks/utility.duck';
import MainDashboardWrapper from '../../components/MainDashboardWrapper/MainDashboardWrapper';
// import Offer from '../../assets/30off.png';

const STRIPE_ONBOARDING_RETURN_URL_SUCCESS = 'success';
const STRIPE_ONBOARDING_RETURN_URL_FAILURE = 'failure';
const STRIPE_ONBOARDING_RETURN_URL_TYPES = [
  STRIPE_ONBOARDING_RETURN_URL_SUCCESS,
  STRIPE_ONBOARDING_RETURN_URL_FAILURE,
];

// Create return URL for the Stripe onboarding form
const createReturnURL = (returnURLType, rootURL, routes) => {
  const path = createResourceLocatorString(
    'StripePayoutOnboardingPage',
    routes,
    { returnURLType },
    {}
  );
  const root = rootURL.replace(/\/$/, '');
  return `${root}${path}`;
};

// const { UUID } = sdkTypes;
// Get attribute: stripeAccountData
const getStripeAccountData = stripeAccount => stripeAccount.attributes.stripeAccountData || null;

// Get last 4 digits of bank account returned in Stripe account
const getBankAccountLast4Digits = stripeAccountData =>
  stripeAccountData && stripeAccountData.external_accounts.data.length > 0
    ? stripeAccountData.external_accounts.data[0].last4
    : null;

// Check if there's requirements on selected type: 'past_due', 'currently_due' etc.
const hasRequirements = (stripeAccountData, requirementType) =>
  stripeAccountData != null &&
  stripeAccountData.requirements &&
  Array.isArray(stripeAccountData.requirements[requirementType]) &&
  stripeAccountData.requirements[requirementType].length > 0;

// Redirect user to Stripe's hosted Connect account onboarding form.
// Uses window.top.location so we burst out of any iframe wrapper. The
// FTW app is sometimes embedded inside coach.viveka.world (Go High
// Level marketing site); inside an iframe, navigating window.location
// just navigates the iframe, but Stripe Connect refuses to load
// inside iframes (X-Frame-Options: DENY) and the user sees
// 'connect.stripe.com refused to connect'. Navigating window.top
// lifts the whole tab to Stripe instead.
const handleGetStripeConnectAccountLinkFn = (getLinkFn, commonParams) => type => () => {
  getLinkFn({ type, ...commonParams })
    .then(url => {
      try {
        if (window.top && window.top !== window.self) {
          window.top.location.href = url;
        } else {
          window.location.href = url;
        }
      } catch (e) {
        // Cross-origin frame access can throw — fall back to in-frame
        // navigation (which would 'refused to connect' but at least we
        // tried). In practice this fallback rarely fires because the
        // marketing site and FTW are on the same eTLD+1 (viveka.world).
        window.location.href = url;
      }
    })
    .catch(err => console.error(err));
};

export const StripePayoutPageComponent = props => {
  const {
    currentUser,
    // scrollingDisabled,
    getAccountLinkInProgress,
    createStripeAccountError,
    updateStripeAccountError,
    fetchStripeAccountError,
    stripeAccountFetched,
    stripeAccount,
    onPayoutDetailsFormChange,
    onPayoutDetailsFormSubmit,
    onGetStripeConnectAccountLink,
    payoutDetailsSaveInProgress,
    payoutDetailsSaved,
    params,
    intl,
    // history,
    // location,
    onFetchCurrentUser,
    onRemoveSubscription,
    onReactivateSubscription,
    onCheckProfileCompleted,
    onFetchPortalSession,
  } = props;

  const [value, setValue] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [valuetabIndex, setValuetabIndex] = useState(false);

  // ---- Early-member eligibility ----
  // Eligibility is owned by the backend (subscription-service /eligible-plans).
  // If the coach's Sharetribe createdAt pre-dates GRANDFATHER_CUTOFF_DATE,
  // they're an early member and the Lifetime SKU (Legacy-Subscriber---Lifetime,
  // $997 one-time) is offered to them in addition to the standard Network
  // ($19/$197) and Verified ($49/$497) plans. Non-eligible coaches see
  // standard pricing only — no Lifetime card.
  //
  // The frontend never inspects the cutoff date directly. We just call the
  // endpoint and render conditionally on what comes back. The /checkout
  // endpoint re-validates eligibility server-side on submit, so a crafted
  // request can't bypass the gate.
  //
  // Note: First Mover monthly/annual SKUs (50% off) have been retired as
  // of May 2026. The plan IDs are kept in the codebase for backward compat
  // with coaches still on those subscriptions (so the "Active Plan"
  // indicator can recognize them), but they are no longer sold.
  const [lifetimeSeats, setLifetimeSeats] = useState(null); // { seatsSold, seatLimit, seatsRemaining }

  // Billing cycle toggle for the early-member panel. Monthly is default
  // (it carries the 7-day free trial). Switching to annual swaps prices,
  // plan IDs, and CTA copy on the Network and Verified cards. Lifetime
  // is unaffected — it has no period.
  const [isAnnual, setIsAnnual] = useState(false);

  // Cancellation flow lives entirely in the Chargebee customer portal that
  // opens via the Manage Subscription button. We tried building a native
  // confirm modal + cancel button on this page (May 7) but it duplicated
  // what Chargebee already does well, so we reverted to portal-only cancel.
  // What we DO keep on this page is:
  //   - the "Cancellation scheduled" badge (useful regardless of which UI
  //     the coach used to cancel — it shows at-a-glance status)
  //   - the Reactivate Subscription button (one-click un-schedule of the
  //     pending cancellation, talks to /chargebee/reactivate-subscription)
  //   - the SubscriptionExpiryBanner that renders on every dashboard page
  //     when a coach has < 7 days of access remaining or has a cancellation
  //     scheduled (lives in MainDashboardWrapper, not this file)

  // Reactivation flow — when a coach has already scheduled a cancellation
  // (`subscriptionCancellation` on metadata) we show a "Reactivate
  // Subscription" button that un-schedules the cancellation in Chargebee
  // (status flips back from non_renewing to active) and clears the
  // Sharetribe flag. One-click action; no confirm modal — reactivation
  // is a non-destructive action and we don't want to friction-gate
  // someone who's having second thoughts about leaving.
  const [reactivating, setReactivating] = useState(false);
  const [reactivateError, setReactivateError] = useState(null);

  // Fetch the live Lifetime seat count from the backend. Eligibility itself
  // is computed client-side (see isLegacyEligible below) from createdAt vs
  // config.firstMoverCutoffDate, so the correct panel renders on first paint
  // with no round-trip. We still hit /eligible-plans here for the seat count
  // because that's real backend state. The /checkout endpoint validates
  // eligibility server-side on submit, so this client-side check is purely
  // for UI rendering — it can't be exploited.
  useEffect(() => {
    const userId = currentUser && currentUser.id && currentUser.id.uuid;
    const createdAt = currentUser && currentUser.attributes && currentUser.attributes.createdAt;
    if (!userId || !createdAt) return;

    axios
      .post(`${config.subscriptionServiceUrl}eligible-plans`, { createdAt }, {
        headers: { 'content-type': 'application/json' },
      })
      .then(res => {
        if (res.data && res.data.lifetime) {
          setLifetimeSeats(res.data.lifetime);
        }
      })
      .catch(err => {
        console.error('[pricing] eligible-plans error:', err && err.message);
      });
  }, [currentUser && currentUser.id && currentUser.id.uuid]);

  // Funnel analytics: fire publish_gate_shown when the coach lands here
  // via the EditListingPage publish gate (?gate=publish in URL). Fires
  // once per page load.
  useEffect(() => {
    if (typeof window === 'undefined' || !window.dataLayer) return;
    const search = (window.location && window.location.search) || '';
    if (search.indexOf('gate=publish') !== -1) {
      window.dataLayer.push({ event: 'publish_gate_shown' });
    }
  }, []);

  // Standard plan IDs (everyone sees these). Match Chargebee plan IDs
  // registered in subscription-service/scripts/plans.js.
  const STD_NETWORK_PLAN_ID = 'Network-Member---Monthly';
  const STD_NETWORK_ANNUAL_PLAN_ID = 'Network-Member-Annual';
  const STD_VERIFIED_PLAN_ID = 'Verified-Coach-Monthly';
  const STD_VERIFIED_ANNUAL_PLAN_ID = 'Verified-Coach---Annual';
  // First Mover plan IDs (only offered when the backend says the user
  // qualifies — i.e. account created before GRANDFATHER_CUTOFF_DATE).
  const FM_NETWORK_PLAN_ID = 'First-Mover-Network-Monthly';
  const FM_NETWORK_ANNUAL_PLAN_ID = 'First-Mover-Network-Annual';
  const FM_VERIFIED_PLAN_ID = 'First-Mover-Verified-Monthly';
  const FM_VERIFIED_ANNUAL_PLAN_ID = 'First-Mover-Verified-Annual';
  // Checkout target for new Lifetime purchases from this page — points at
  // the current Chargebee plan. Existing subscribers on the old
  // Legacy-Subscriber---Lifetime plan are still recognized as Lifetime via
  // LIFETIME_PLAN_IDS below; this constant only affects NEW checkouts.
  const FM_LIFETIME_PLAN_ID = 'First-Mover-Lifetime-Forever';
  // Active plan IDs swap between monthly and annual based on the toggle.
  // Used by the Network and Verified cards. Lifetime has no period swap.
  const activeFmNetworkPlanId = isAnnual ? FM_NETWORK_ANNUAL_PLAN_ID : FM_NETWORK_PLAN_ID;
  const activeFmVerifiedPlanId = isAnnual ? FM_VERIFIED_ANNUAL_PLAN_ID : FM_VERIFIED_PLAN_ID;
  const activeStdNetworkPlanId = isAnnual ? STD_NETWORK_ANNUAL_PLAN_ID : STD_NETWORK_PLAN_ID;
  const activeStdVerifiedPlanId = isAnnual ? STD_VERIFIED_ANNUAL_PLAN_ID : STD_VERIFIED_PLAN_ID;

  // Eligibility used to be computed from createdAt vs the cutoff env var,
  // restricting the First 100 / Lifetime panel to early signups. That gate
  // is now disabled — every coach sees the First 100 panel and the $997
  // Lifetime card, regardless of signup date.
  //
  // IMPORTANT: the subscription-service backend's /checkout endpoint
  // independently re-validates createdAt-based eligibility (see
  // subscription-service/scripts/plans.js) and will still reject Lifetime
  // purchases from coaches who don't pass that server-side check. Until
  // the backend gate is relaxed to match, non-eligible coaches will see
  // the card but get a checkout error when they try to buy it.
  const isLegacyEligible = true;

  // Plan IDs the on-card buttons should target. Eligible coaches subscribe
  // to First Mover SKUs; everyone else gets standard SKUs. The view switch
  // is in the JSX below — eligible users see the thank-you panel, non-
  // eligible users see the standard 2-card layout.
  const LEGACY_LIFETIME_PLAN_ID = FM_LIFETIME_PLAN_ID;

  // Lifetime seat counter (hydrated from /eligible-plans response).
  const lifetimeSeatsRemaining =
    lifetimeSeats && typeof lifetimeSeats.seatsRemaining === 'number'
      ? lifetimeSeats.seatsRemaining
      : null;
  const lifetimeSeatLimit =
    lifetimeSeats && typeof lifetimeSeats.seatLimit === 'number'
      ? lifetimeSeats.seatLimit
      : 100;

  // ── Resume an intended plan from the marketing landing pages ─────────
  // A coach who clicked "Claim Your Founding Seat" / "Start Monthly" on
  // coach.viveka.world arrives here with that choice captured (?plan=…&
  // period=… → localStorage via util/intendedPlan), having passed through
  // login/signup in between. Resume the funnel automatically: preselect
  // the billing period and open the matching Chargebee checkout, so they
  // don't have to re-find the plan they already picked. Fires once, and
  // only for coaches WITHOUT an active subscription (never hijacks someone
  // who came here to manage existing billing).
  // Verified false positive from eslint-plugin-react-hooks@1.7.0 (a 2019-era
  // version of the plugin, well predating this codebase's other work): it
  // flags these two hooks as "conditional" with no actual conditional
  // preceding them — confirmed by direct AST inspection (both are direct,
  // unconditional statements in this component's top-level body) and by a
  // minimal repro (truncating this file right after this useEffect makes
  // the false positive disappear; the mid-render `if (...) return;` further
  // down at validPricingTab, combined with this component's size, appears
  // to confuse this old plugin version's control-flow analysis). Pre-
  // existing — unrelated to any recent change to this file.
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const intendedResumeFired = useRef(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (intendedResumeFired.current) return;

    const intent = getIntendedPlan();
    if (!intent) return;

    const userLoaded = currentUser && currentUser.id && currentUser.id.uuid;
    if (!userLoaded) return; // wait until the user record is hydrated

    const md =
      currentUser.attributes &&
      currentUser.attributes.profile &&
      currentUser.attributes.profile.metadata;
    const hasActiveSub = !!(
      md &&
      md.subscriptionDetails &&
      md.subscriptionDetails.subscriptionId
    );
    if (hasActiveSub) {
      clearIntendedPlan();
      return;
    }

    // Resolve the tier intent → concrete Chargebee plan ID, honoring
    // First Mover eligibility and the chosen period. Lifetime is First
    // Mover-only and has no period.
    const wantAnnual = intent.period === 'annual';
    let planId = null;
    if (intent.plan === 'lifetime') {
      if (isLegacyEligible) planId = FM_LIFETIME_PLAN_ID;
    } else if (intent.plan === 'network') {
      planId = isLegacyEligible
        ? wantAnnual
          ? FM_NETWORK_ANNUAL_PLAN_ID
          : FM_NETWORK_PLAN_ID
        : wantAnnual
        ? STD_NETWORK_ANNUAL_PLAN_ID
        : STD_NETWORK_PLAN_ID;
    } else if (intent.plan === 'verified') {
      planId = isLegacyEligible
        ? wantAnnual
          ? FM_VERIFIED_ANNUAL_PLAN_ID
          : FM_VERIFIED_PLAN_ID
        : wantAnnual
        ? STD_VERIFIED_ANNUAL_PLAN_ID
        : STD_VERIFIED_PLAN_ID;
    }

    // Unresolvable intent (e.g. lifetime requested but coach isn't First
    // Mover-eligible, or seats sold out). Leave them on the page to choose
    // — don't clear, in case eligibility hydrates on a later render.
    if (!planId) return;

    // Commit: reflect the period in the toggle, then open checkout once
    // the Chargebee script is ready. If it never loads (~10s), give up
    // silently — the period is already preselected so they can click.
    intendedResumeFired.current = true;
    clearIntendedPlan();
    if (wantAnnual) setIsAnnual(true);

    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (typeof window !== 'undefined' && window.Chargebee) {
        clearInterval(timer);
        openChargebeePortal(planId);
      } else if (tries > 20) {
        clearInterval(timer);
      }
    }, 500);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser && currentUser.id && currentUser.id.uuid, isLegacyEligible]);

  console.log(tabIndex);
  // const [chargeBeeLoading, setChargeBeeLoading] = useState(false);

  // const [chargebeeRes, setChargebeeRes] = useState({});
  // const [iframeEnabled, setIframeEnabled] = useState(false);

  const { returnURLType, tab } = params;

  // console.log('****' + returnURLType);
  // console.log('****' + tab);

  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const currentUserLoaded = !!ensuredCurrentUser.id;
  const stripeConnected = currentUserLoaded && !!stripeAccount && !!stripeAccount.id;

  // const title = intl.formatMessage({ id: 'StripePayoutPage.title' });

  const formDisabled = getAccountLinkInProgress;

  const rootURL = config.canonicalRootURL;
  const routes = routeConfiguration();
  const successURL = createReturnURL(STRIPE_ONBOARDING_RETURN_URL_SUCCESS, rootURL, routes);
  const failureURL = createReturnURL(STRIPE_ONBOARDING_RETURN_URL_FAILURE, rootURL, routes);

  const accountId = stripeConnected ? stripeAccount.id : null;
  const stripeAccountData = stripeConnected ? getStripeAccountData(stripeAccount) : null;
  const requirementsMissing =
    stripeAccount &&
    (hasRequirements(stripeAccountData, 'past_due') ||
      hasRequirements(stripeAccountData, 'currently_due'));

  const savedCountry = stripeAccountData ? stripeAccountData.country : null;

  const handleGetStripeConnectAccountLink = handleGetStripeConnectAccountLinkFn(
    onGetStripeConnectAccountLink,
    {
      accountId,
      successURL,
      failureURL,
    }
  );

  const returnedNormallyFromStripe = returnURLType === STRIPE_ONBOARDING_RETURN_URL_SUCCESS;
  const showVerificationError = returnURLType === STRIPE_ONBOARDING_RETURN_URL_FAILURE;
  const showVerificationNeeded = stripeConnected && requirementsMissing;

  // Redirect from success URL to basic path for StripePayoutPage
  if (returnedNormallyFromStripe && stripeConnected && !requirementsMissing) {
    return <NamedRedirect name="StripePayoutPage" />;
  }

  // function payMemberShipFee() {
  //   alert('pay your membership Fee');
  // }

  // const handleBookingSubmit = values => {
  //   //const {  history , location } = props;
  //
  //   const { params, callSetInitialValues, onInitializeCardPaymentData } = props;
  //
  //   const paymentPlan = 'classic';
  //   const timePeriod = 'monthly';
  //   const price = '70';
  //
  //   const initialValues = {
  //     paymentPlan,
  //     timePeriod,
  //     price,
  //   };
  //
  //   /*
  //   const routes = routeConfiguration();
  //   //Customize checkout page state with current listing and selected bookingDates
  //   const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);
  //   callSetInitialValues(setInitialValues, initialValues);
  //
  //   //Clear previous Stripe errors from store if there is any
  //   onInitializeCardPaymentData();
  //
  //   //Redirect to CheckoutPage
  //   console.log(routes);
  //   console.log(props);
  //
  //   const history = createHashHistory();
  //
  //   console.log(history);
  //
  //   history.push(
  //     createResourceLocatorString(
  //       'CheckoutPage',
  //       routes,
  //       { id: "5e639cf9-1774-43e0-bf15-d6bea5c43ffa", slug: createSlug("payment") },
  //       {}
  //     )
  //   );
  //   */
  // };
  // let simpleDialog;

  // const ChargeBeeComponent = () => {
  //   const url = chargebeeRes.data && chargebeeRes.data.hosted_page.url;
  //
  //   return (
  //     iframeEnabled && (
  //       <iframe style={{ border: 'none' }} src={url} height="100%" width="100%"></iframe>
  //     )
  //   );
  // };

  // const getPlanStr = () => {
  //   if (value && showClassicSelected) {
  //     return 'annual-membership-fee';
  //   }

  //   if (!value && showClassicSelected) {
  //     // return 'classic-monthly'
  //     return 'viveka-monthly-membership-fee';
  //   }

  //   if (value && showPremiumSelected) {
  //     return 'premium-membership';
  //   }

  //   if (!value && showPremiumSelected) {
  //     // return 'premium-monthly'
  //     return 'monthly_preferred-membership';
  //   }
  // };

  // const onPayment = plan => {
  //   setIframeEnabled(true);
  //   // console.log(ensuredCurrentUser);
  //   const subscriptionId =
  //     ensuredCurrentUser.attributes.profile.metadata &&
  //     ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails &&
  //     ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails.subscriptionId;
  //
  //   const model = simpleDialog;
  //
  //   const email = ensuredCurrentUser.attributes.email;
  //   // const plan = getPlanStr();
  //
  //   // console.log(config.subscriptionServiceUrl);
  //
  //   // console.log('plan', getPlanStr());
  //   const params = subscriptionId
  //     ? {
  //       email: email,
  //       plan: plan,
  //       subscriptionId: subscriptionId,
  //     }
  //     : {
  //       email: email,
  //       plan: plan,
  //     };
  //
  //   setChargeBeeLoading(true);
  //   axios
  //     .post(`${config.subscriptionServiceUrl}checkout`, params, {
  //       headers: {
  //         'content-type': 'application/json',
  //       },
  //     })
  //     .then(res => {
  //       setChargeBeeLoading(false);
  //       console.log(res);
  //       setChargebeeRes(res);
  //       model.show();
  //     })
  //     .catch(err => {
  //       setChargeBeeLoading(false);
  //       console.log(err);
  //     });
  // };

  // const modelStyle =
  //   window.outerWidth > 650
  //     ? {
  //       top: '0px',
  //       height: '100vh',
  //       marginTop: '0'
  //
  //     }
  //     : {
  //       width: 'auto',
  //       marginTop: '0',
  //       marginLeft: 0,
  //       minHeight: '100px',
  //       top: '50px',
  //       left: '20px',
  //       right: '20px',
  //       height: '90vh',
  //     };

  const getSubscriptionType = () => {
    return (
      ensuredCurrentUser.attributes.profile.metadata &&
      ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails &&
      ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails.subscriptionName
    );
  };
  const subscription =  ensuredCurrentUser?.attributes?.profile?.metadata?.subscriptionDetails?.subscription

  // ── Active-plan detection ────────────────────────────────────────────
  // Map every plan ID (First Mover + standard) to a tier-level card so the
  // pricing UI can show "✓ ACTIVE PLAN" on whichever card matches the
  // coach's current subscription — regardless of whether the toggle is on
  // Monthly or Annual. This is broader than the existing per-card
  // `getSubscriptionType() === activeFmNetworkPlanId` check, which only
  // matches when the toggle frequency matches the coach's billing
  // frequency.
  const currentPlanId = getSubscriptionType();
  const NETWORK_PLAN_IDS = [
    'Network-Member---Monthly',
    'Network-Member-Annual',
    'First-Mover-Network-Monthly',
    'First-Mover-Network-Annual',
  ];
  const VERIFIED_PLAN_IDS = [
    'Verified-Coach-Monthly',
    'Verified-Coach---Annual',
    'First-Mover-Verified-Monthly',
    'First-Mover-Verified-Annual',
  ];
  // First-Mover-Lifetime-Installments-Monthly (sold only via the standalone
  // /checkout-lifetime-payment-plan page, not from a checkout button on
  // this page) is included here so a coach mid-installments — or already converted —
  // sees the Lifetime card as their active plan too, instead of it looking
  // unrecognized. isCurrentInstallment below distinguishes the two so the
  // badge/button copy doesn't claim they paid $997 upfront when they're on
  // the 3-payment plan.
  const LIFETIME_PLAN_IDS = [
    'Legacy-Subscriber---Lifetime',
    'First-Mover-Lifetime-Forever',
    'First-Mover-Lifetime-Installments-Monthly',
  ];
  const isCurrentNetwork = NETWORK_PLAN_IDS.indexOf(currentPlanId) !== -1;
  const isCurrentVerified = VERIFIED_PLAN_IDS.indexOf(currentPlanId) !== -1;
  const isCurrentLifetime = LIFETIME_PLAN_IDS.indexOf(currentPlanId) !== -1;
  const isCurrentInstallment = currentPlanId === 'First-Mover-Lifetime-Installments-Monthly';

  // Opens the Chargebee customer portal where users can update their card,
  // view invoices, change plan, and cancel/resume their subscription.
  // Backed by /chargebee/portal-session in subscription-service.
  function openManageSubscription() {
    const Chargebee = window.Chargebee;
    const chargebeeInstance = Chargebee.init({
      site: config.chargebeeSiteName,
    });

    chargebeeInstance.setPortalSession(() => {
      return onFetchPortalSession();
    });

    const cbPortal = chargebeeInstance.createChargebeePortal();
    cbPortal.open({
      close: () => {
        // Refresh the user record so any plan / cancellation changes the user
        // made inside the portal show up immediately on the pricing page.
        sleep(2000).then(() => {
          onFetchCurrentUser();
        });
      },
    });
  }

  function openChargebeePortal(plan) {
    // Funnel analytics: emit checkout_started so we can measure the
    // drop-off between publish_gate_shown / pricing-page-shown and the
    // actual checkout attempt.
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'checkout_started',
        plan,
      });
    }

    const Chargebee = window.Chargebee;
    const chargebeeInstance = Chargebee.init({
      site: config.chargebeeSiteName,
    });
    // Same-origin redirect target. window.location.origin keeps prod
    // coaches on market.viveka.world and demo coaches on demo.viveka.world
    // — Chargebee admin's global Success URL is overridden by this.
    // We land users on the dedicated /welcome page with ?plan=<planId> so
    // WelcomePage can render the tier-specific celebration (Network /
    // Verified / Lifetime).
    const redirectUrl = `${window.location.origin}/welcome?plan=${encodeURIComponent(plan)}`;

    chargebeeInstance.openCheckout({
      hostedPage: () => {
        return new Promise(function(resolve, reject) {
          const subscriptionId =
            ensuredCurrentUser.attributes.profile.metadata &&
            ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails &&
            ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails.subscriptionId;

          const email = ensuredCurrentUser.attributes.email;

          const flexUserUUID =
            ensuredCurrentUser && ensuredCurrentUser.id && ensuredCurrentUser.id.uuid;

          // createdAt is required by the backend /checkout endpoint to
          // re-validate eligibility for legacy plans. Without it, the
          // backend rejects requests for Legacy-Subscriber-* plans.
          const createdAt =
            ensuredCurrentUser &&
            ensuredCurrentUser.attributes &&
            ensuredCurrentUser.attributes.createdAt;

          // V-coins referral: if this coach landed via a referral link
          // (?ref=CODE), pass the stored code so the backend validates it
          // and auto-applies the 20% discount on the Hosted Page. Only on
          // NEW subscriptions — upgrades aren't referrals.
          const referralCoupon = subscriptionId ? null : getReferralCode();

          const params = subscriptionId
            ? {
                email: email,
                plan: plan,
                flexUserUUID,
                subscriptionId: subscriptionId,
                createdAt,
                redirectUrl,
              }
            : {
                email: email,
                plan: plan,
                flexUserUUID,
                createdAt,
                redirectUrl,
                ...(referralCoupon ? { coupon: referralCoupon } : {}),
              };
          // console.log(params);
          axios
            .post(`${config.subscriptionServiceUrl}checkout`, params, {
              headers: {
                'content-type': 'application/json',
              },
            })
            .then(res => {
              resolve(res.data.hosted_page);
            })
            .catch(err => {
              console.log(err);
              reject(err);
            });
        });
      },
      // Fires when Chargebee confirms payment succeeded. We navigate
      // explicitly here so the user is dropped back onto the marketplace
      // they came from (demo OR market.viveka.world), instead of dead-
      // ending on Chargebee's hosted Thank You page.
      success: () => {
        // The referral code is single-use per visitor — clear it so a
        // later upgrade/plan change doesn't re-send it.
        clearReferralCode();
        window.location.href = redirectUrl;
      },
      close: () => {
        sleep(7000).then(() => {
          onFetchCurrentUser();
          onCheckProfileCompleted();
          console.log('current user refreshed');
        });
      },
    });
  }

  // Routes both first-time subscribing and switching an existing plan to
  // the embedded, on-brand checkout page instead of Chargebee's hosted
  // popup — see CheckoutPlanLoggedInPage.js, which branches internally on
  // whether the coach already has a subscriptionId (proration is computed
  // server-side via Chargebee's estimate API in that case, see
  // subscription-service/app.js's /payment-intent and
  // /checkout/subscribe-with-intent). openChargebeePortal above is no
  // longer called from the pricing-card buttons, but stays in place for
  // the ?intent= deep-link auto-resume flow above and the "Manage
  // Subscription" customer-portal entry point.
  //
  // A full navigation, not history.push: this page has already called
  // window.Chargebee.init() (for openChargebeePortal/openManageSubscription
  // above). Landing on CheckoutPlanLoggedInPage.js via client-side routing
  // would keep that same JS context alive and call Chargebee.init() +
  // components.create('payment') a second time mid-session — confirmed
  // live elsewhere in this app to break the Payment Component entirely
  // ("Payment form unavailable", card fields cut off; see
  // CheckoutPlanPage.js's header comment). A real page load gives the new
  // page a fresh context, same reasoning as that file's coupon reload.
  function goToLoggedInCheckout(tier) {
    if (typeof window !== 'undefined') {
      window.location.href = `/account/checkout-plan/${tier}?period=${isAnnual ? 'annual' : 'monthly'}`;
    }
  }

  // const pubData = currentUser && currentUser.attributes.profile.publicData;
  // const isProvider = pubData && !!pubData.isProvider;

  // if (!isProvider === true){
  //   history && history.push('/profile-settings')
  // }

  // if (!isProvider === true){
  //   history && history.push('/account/payments/withdrawal')
  // }

  const validTab = tab === 'withdrawal';
  if (validTab && !valuetabIndex) {
    setTabIndex(1);
    setValuetabIndex(true);
    return;
  }

  const validPricingTab = tab === 'pricing';
  if (validPricingTab && !valuetabIndex) {
    setTabIndex(0);
    setValuetabIndex(true);
    return;
  }

  const getSubscriptionName = subscriptionAlias => {
    switch (subscriptionAlias) {
      // ── Current Chargebee plans ───────────────────────
      case 'Network-Member---Monthly':
        return 'Network Member - Monthly';
      case 'Network-Member-Annual':
        return 'Network Member - Annual';
      case 'Verified-Coach-Monthly':
        return 'Verified Coach - Monthly';
      case 'Verified-Coach---Annual':
        return 'Verified Coach - Annual';
      case 'First-Mover-Network-Monthly':
        return 'First Mover Network - Monthly';
      case 'First-Mover-Network-Annual':
        return 'First Mover Network - Annual';
      case 'First-Mover-Verified-Monthly':
        return 'First Mover Verified - Monthly';
      case 'First-Mover-Verified-Annual':
        return 'First Mover Verified - Annual';
      case 'Legacy-Subscriber---Lifetime':
      case 'First-Mover-Lifetime-Forever':
        return 'First Mover Lifetime';
      case 'First-Mover-Lifetime-Installments-Monthly':
        return 'First Mover Lifetime — 3 Installments';
      // ── Legacy plan IDs (existing subscribers — display only) ─
      case 'viveka-network-monthly':
      case 'viveka-monthly-membership-fee':
        return 'Viveka Network - Monthly';
      case 'annual-membership-fee':
        return 'Viveka Network - Annual';
      case 'viveka-verified-monthly':
      case 'monthly_preferred-membership':
        return 'Viveka Verified Coach - Monthly';
      case 'premium-membership':
        return 'Viveka Verified Coach - Annual';
      default:
        return 'N/A';
    }
  };

  // Cancellation now happens via the Chargebee customer portal (Manage
  // Subscription button → portal iframe → cancel within the portal flow).
  // Kept for any legacy callers, but no UI element invokes this directly.
  const onRemoveButtonClick = () => {
    if (window.confirm('This will cancel the subscription and remove your token, are you sure?')) {
      onRemoveSubscription();
    }
  };

  // One-click reactivation. Calls the existing onReactivateSubscription
  // dispatch (POST /chargebee/reactivate-subscription) which unschedules
  // the cancellation in Chargebee + clears subscriptionCancellation in
  // Sharetribe + re-fetches currentUser. After it resolves the badge
  // disappears and the Cancel button re-appears.
  const onReactivateClick = async () => {
    if (reactivating) return;
    setReactivating(true);
    setReactivateError(null);
    try {
      await onReactivateSubscription();
    } catch (e) {
      setReactivateError('Sorry, we couldn\'t reactivate your subscription. Please try again or contact support.');
    } finally {
      setReactivating(false);
    }
  };

  const subscriptionCancellation =
    ensuredCurrentUser?.attributes?.profile?.metadata?.subscriptionCancellation;
  const subscriptionDetails =
    ensuredCurrentUser?.attributes?.profile?.metadata?.subscriptionDetails;
  // Lifetime subscribers are non-cancellable per Subscription Gating
  // Spec §5.4. Detected via the `isLifetime` flag the webhook writes
  // (subscription.js → updateUser sets isLifetime: true for the
  // Legacy-Subscriber---Lifetime plan), with a planId fallback for
  // resilience against backfilled / legacy metadata that may not have
  // the flag yet.
  const isLifetimeSubscriber =
    !!(subscriptionDetails &&
      (subscriptionDetails.isLifetime === true ||
        subscriptionDetails.planId === 'Legacy-Subscriber---Lifetime' ||
        subscriptionDetails.planId === 'First-Mover-Lifetime-Forever'));

  return (
    <PageWrapper>
      <MainDashboardWrapper title={'Settings'} page={'all-setting'}>
        {/* {tab === 'pricing' ?  */}
        <div className={css.wrapper}>
          {tab === 'pricing' ? (
            <SettingsLayoutWrapper page="payments">
              {/* <DashboardPaymentsWrapper /> */}
              {/* <ContainerWrapper> */}
              <div className={css.outerbase}>
                {/*
                  ── Signup-intent recommendation banner ─────────────
                  When the coach came from the marketing site with
                  ?intent=<tier> (set on coach.viveka.world CTAs and
                  carried through SignUpPage to here), we show a soft
                  recommendation pointing at the matching card and emit
                  the publish_gate_shown event for funnel analytics.
                */}
                {(() => {
                  if (typeof window === 'undefined') return null;
                  // Intent priority: URL ?intent=... wins, then sessionStorage.
                  const urlParams = new URLSearchParams(
                    (window.location && window.location.search) || ''
                  );
                  let intent = urlParams.get('intent');
                  if (!intent) {
                    try {
                      intent = window.sessionStorage && window.sessionStorage.getItem('signupIntent');
                    } catch (e) { /* non-fatal */ }
                  }
                  if (!intent) return null;
                  const intentLabels = {
                    'network-monthly': 'Network Member (Monthly)',
                    'network-annual': 'Network Member (Annual)',
                    'verified-monthly': 'Verified Coach (Monthly)',
                    'verified-annual': 'Verified Coach (Annual)',
                    'lifetime': 'Viveka First 100 Lifetime',
                  };
                  const label = intentLabels[intent] || intent;
                  return (
                    <div
                      style={{
                        marginBottom: '24px',
                        padding: '16px 22px',
                        background: 'linear-gradient(135deg, rgba(251,191,36,0.10) 0%, rgba(139,92,246,0.06) 100%)',
                        border: '1px solid rgba(251,191,36,0.40)',
                        borderRadius: '14px',
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                      }}
                    >
                      <div style={{ fontWeight: 800, fontSize: '13px', color: '#92580A', letterSpacing: '0.04em', marginBottom: '4px', textTransform: 'uppercase' }}>
                        Based on your earlier choice
                      </div>
                      <div style={{ fontWeight: 600, fontSize: '15px', color: '#1E1040' }}>
                        We recommend <span style={{ color: '#92580A', fontWeight: 800 }}>{label}</span> — scroll down to confirm.
                      </div>
                    </div>
                  );
                })()}

                {/*
                  ── Publish-gate banner ─────────────────────────────
                  Shown when the coach was redirected here because they
                  tried to publish a listing without an active
                  subscription (EditListingPage.gatedPublishListingDraft
                  sets ?gate=publish on the redirect). Explains why
                  they're on the pricing tab and what to do next.
                */}
                {typeof window !== 'undefined' &&
                  window.location &&
                  window.location.search &&
                  window.location.search.indexOf('gate=publish') !== -1 && (
                    <div
                      style={{
                        marginBottom: '24px',
                        padding: '18px 22px',
                        background: 'linear-gradient(135deg, rgba(139,92,246,0.08) 0%, rgba(251,191,36,0.06) 100%)',
                        border: '1px solid rgba(139,92,246,0.25)',
                        borderRadius: '14px',
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '14px',
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                      }}
                    >
                      <div
                        style={{
                          flex: '0 0 36px',
                          height: '36px',
                          background: '#1E1040',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#FBBF24',
                          fontWeight: 800,
                          fontSize: '18px',
                        }}
                      >
                        ✦
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontWeight: 800,
                            fontSize: '15px',
                            color: '#1E1040',
                            marginBottom: '4px',
                          }}
                        >
                          Pick a plan to publish your listing
                        </div>
                        <div
                          style={{
                            fontSize: '14px',
                            color: '#525252',
                            lineHeight: 1.5,
                          }}
                        >
                          Your listing is saved as a draft. Choose a plan
                          below to publish it and start accepting clients.
                        </div>
                      </div>
                    </div>
                  )}
                {/*<div className={classnames(css.row, css.titleRow)}>*/}
                {/*  <div className={css.leftDivDes}>*/}
                {/*    <p>*/}
                {/*      Your success is our success. Your business is our business. We'll help you*/}
                {/*      make the right choice for your business & life.*/}
                {/*    </p>*/}
                {/*  </div>*/}
                {/*  <div className={css.rightDivDes}>*/}
                {/*    <p>*/}
                {/*      To us, you are more than just a number. When you join Viveka, you immediately*/}
                {/*      become part of our extended family. As one of our exclusive coaches, you'll*/}
                {/*      receive tools and trainings to help you grow. We are here to help you amplify*/}
                {/*      your success in your business, so you can focus on what you do best. One of*/}
                {/*      the signature tools is our proprietary matching technology where you'll*/}
                {/*      automatically be matched with the right potential clients – making it even*/}
                {/*      easier for you to secure your next client. And we provide exclusive trainings*/}
                {/*      to help you continue your growth both professionally AND personally. Because*/}
                {/*      at Viveka, we believe you don't have to compromise your life to succeed. You*/}
                {/*      can have it all!*/}
                {/*    </p>*/}
                {/*  </div>*/}
                {/*</div>*/}

                {/*<div className={css.specialOffer}>
                  <p>Apply coupon code: 30%LAUNCHSPECIAL</p>
                  <img alt="Special offer" src={Offer} />
                </div>*/}
                {/* ── Subscription status card ──────────────────────── */}
                <div className={css.settingsBlock}>
                  <div className={css.blockHeader}>
                    <p className={css.blockTitle}>
                      <span className={css.blockIcon}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M20 12V22H4V12"/>
                          <path d="M22 7H2v5h20V7z"/>
                          <path d="M12 22V7"/>
                          <path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/>
                          <path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>
                        </svg>
                      </span>
                      Coach Subscription
                    </p>
                  </div>
                  <div className={css.blockBody}>
                    <p className={css.introText}>
                      Built for coaches who want more than a directory listing.
                      Operate within a network that connects coaching to real opportunities.
                    </p>

                    {/* Lifetime access notice */}
                    {isLifetimeSubscriber && (
                      <div
                        role="region"
                        aria-label="Lifetime access notice"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '14px',
                          padding: '14px 16px',
                          marginBottom: '8px',
                          borderRadius: '12px',
                          background: 'linear-gradient(90deg, rgba(251,191,36,0.12) 0%, rgba(251,191,36,0.05) 100%)',
                          border: '1px solid rgba(251,191,36,0.45)',
                          color: '#0F172A',
                          flexWrap: 'wrap',
                        }}
                      >
                        <span aria-hidden="true" style={{ fontSize: '20px', lineHeight: 1 }}>✨</span>
                        <div style={{ flex: '1 1 auto', minWidth: '240px' }}>
                          <div style={{ fontWeight: 700, fontSize: '14px', marginBottom: '2px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                            You have lifetime access to Verified Coach
                          </div>
                          <div style={{ fontSize: '13px', lineHeight: 1.5, color: '#334155' }}>
                            Your subscription doesn't renew and won't expire.{' '}
                            <a href="mailto:support@viveka.world" style={{ color: '#8B5CF6', fontWeight: 600 }}>
                              Contact support
                            </a>{' '}
                            for any changes.
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Subscription management toolbar */}
                    {subscriptionDetails && (
                      <div className={css.subToolbar}>
                        {subscriptionCancellation && !isLifetimeSubscriber && (
                          <div
                            className={css.cancellationBadge}
                            title="Your subscription is set to end at the end of the current billing period."
                          >
                            Cancellation scheduled
                          </div>
                        )}

                        <button
                          type="button"
                          className={css.btnManage}
                          onClick={() => openManageSubscription()}
                        >
                          Manage Subscription
                        </button>

                        {/*
                          Reactivate button — one-click un-schedule of a pending
                          cancellation. Hidden for Lifetime subscribers (spec §5.4).
                        */}
                        {subscriptionCancellation && !isLifetimeSubscriber && (
                          <button
                            type="button"
                            className={css.btnReactivate}
                            onClick={onReactivateClick}
                            disabled={reactivating}
                            title="Cancel the scheduled cancellation. Your subscription will continue renewing as normal."
                          >
                            {reactivating ? 'Reactivating…' : 'Reactivate Subscription'}
                          </button>
                        )}

                        {reactivateError && (
                          <div
                            style={{
                              width: '100%',
                              padding: '8px 12px',
                              borderRadius: '8px',
                              background: 'rgba(220,38,38,0.07)',
                              border: '1px solid rgba(220,38,38,0.35)',
                              color: '#991B1B',
                              fontSize: '13px',
                              marginTop: '4px',
                            }}
                          >
                            {reactivateError}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {!currentUserLoaded ? (
                  /*
                    ── Loading placeholder ────────────────────────────
                    Only renders on a truly cold first load before the
                    Sharetribe currentUser fetch resolves. Once user is
                    in redux state (any subsequent navigation), the
                    correct panel renders on first paint because
                    isLegacyEligible is computed client-side from
                    createdAt + config.firstMoverCutoffDate.
                    Match approximate panel dimensions to avoid CLS.
                  */
                  <div
                    style={{
                      marginTop: '8px',
                      padding: '60px 32px',
                      borderRadius: '20px',
                      background: 'linear-gradient(180deg, rgba(30,16,64,0.04) 0%, rgba(30,16,64,0.02) 100%)',
                      border: '1px solid rgba(139,92,246,0.08)',
                      minHeight: '420px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'rgba(30,16,64,0.4)',
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontSize: '14px',
                      fontWeight: 500,
                      letterSpacing: '0.05em',
                    }}
                  >
                    Loading subscription options…
                  </div>
                ) : isLegacyEligible ? (
                  /*
                    ── Early-member panel ─────────────────────────────
                    Coaches with Sharetribe createdAt < May 1, 2026 see
                    this panel: three cards at standard pricing
                    (Network $19/$197, Verified $49/$497) plus a
                    Lifetime $997 card gated to the first 100. Non-
                    eligible coaches see the standard two-card panel
                    below — Lifetime is hidden from them entirely.
                  */
                  <div
                    style={{
                      marginTop: '8px',
                      padding: '36px 32px',
                      borderRadius: '20px',
                      background: 'linear-gradient(180deg, #1E1040 0%, #3B0764 100%)',
                      color: '#fff',
                      boxShadow: '0 30px 80px -25px rgba(30,16,64,0.55)',
                    }}
                  >
                    <div style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 28px' }}>
                      <div
                        style={{
                          display: 'inline-block',
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                          fontWeight: 700,
                          fontSize: '11px',
                          letterSpacing: '0.18em',
                          textTransform: 'uppercase',
                          color: '#1E1040',
                          background: '#FBBF24',
                          padding: '6px 14px',
                          borderRadius: '999px',
                          marginBottom: '20px',
                        }}
                      >
                        The First 100 · Early Member
                      </div>
                      <h2
                        style={{
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                          fontWeight: 800,
                          fontSize: '28px',
                          lineHeight: 1.2,
                          color: '#fff',
                          margin: '0 0 14px',
                          letterSpacing: '-0.02em',
                        }}
                      >
                        Welcome back to Viveka.
                      </h2>
                      <p style={{ fontSize: '15px', color: '#C4B5FD', lineHeight: 1.65, margin: 0 }}>
                        You joined the network early. As one of our First 100, you can lock in <strong style={{ color: '#FBBF24' }}>lifetime Verified Coach access</strong> at a one-time rate. Monthly and annual membership remain available at standard pricing.{lifetimeSeatsRemaining !== null ? ' Lifetime is limited to ' + lifetimeSeatLimit + ' positions — ' + lifetimeSeatsRemaining + ' remaining.' : ''}
                      </p>
                    </div>

                    {/* Monthly / Annual billing cycle toggle */}
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                      <div
                        role="tablist"
                        aria-label="Billing cycle"
                        style={{
                          display: 'inline-flex',
                          background: 'rgba(255,255,255,0.05)',
                          border: '1px solid rgba(192,132,252,0.2)',
                          borderRadius: '999px',
                          padding: '4px',
                        }}
                      >
                        <button
                          type="button"
                          role="tab"
                          aria-selected={!isAnnual}
                          onClick={() => setIsAnnual(false)}
                          style={{
                            background: !isAnnual ? '#FBBF24' : 'transparent',
                            color: !isAnnual ? '#1E1040' : 'rgba(255,255,255,0.7)',
                            border: 'none',
                            padding: '8px 22px',
                            borderRadius: '999px',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontSize: '13px',
                            fontWeight: 700,
                            letterSpacing: '0.04em',
                            cursor: 'pointer',
                            transition: 'all .2s ease',
                          }}
                        >
                          Monthly
                        </button>
                        <button
                          type="button"
                          role="tab"
                          aria-selected={isAnnual}
                          onClick={() => setIsAnnual(true)}
                          style={{
                            background: isAnnual ? '#FBBF24' : 'transparent',
                            color: isAnnual ? '#1E1040' : 'rgba(255,255,255,0.7)',
                            border: 'none',
                            padding: '8px 22px',
                            borderRadius: '999px',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontSize: '13px',
                            fontWeight: 700,
                            letterSpacing: '0.04em',
                            cursor: 'pointer',
                            transition: 'all .2s ease',
                          }}
                        >
                          Annual
                        </button>
                      </div>
                    </div>

                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))',
                        gap: '16px',
                        alignItems: 'stretch',
                        maxWidth: '900px',
                        margin: '0 auto',
                      }}
                    >
                      <div
                        style={{
                          position: 'relative',
                          background: isCurrentNetwork ? 'rgba(16,185,129,0.10)' : 'rgba(255,255,255,0.05)',
                          border: isCurrentNetwork ? '2px solid rgba(52,211,153,0.85)' : '1px solid rgba(192,132,252,0.25)',
                          borderRadius: '14px',
                          padding: '28px 24px',
                          display: 'flex',
                          flexDirection: 'column',
                          boxShadow: isCurrentNetwork ? '0 0 0 4px rgba(52,211,153,0.18), 0 10px 28px rgba(16,185,129,0.20)' : 'none',
                          transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
                        }}
                      >
                        {isCurrentNetwork && (
                          <div
                            style={{
                              position: 'absolute',
                              top: '-12px',
                              right: '16px',
                              background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                              color: '#fff',
                              fontFamily: "'Plus Jakarta Sans', sans-serif",
                              fontWeight: 800,
                              fontSize: '10px',
                              letterSpacing: '0.16em',
                              textTransform: 'uppercase',
                              padding: '5px 12px',
                              borderRadius: '999px',
                              whiteSpace: 'nowrap',
                              boxShadow: '0 4px 12px rgba(16,185,129,0.45)',
                            }}
                          >
                            ✓ Your Active Plan
                          </div>
                        )}
                        <div style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.10em', textTransform: 'uppercase', color: '#C084FC', marginBottom: '12px' }}>
                          Network Member
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '34px', color: '#fff', lineHeight: 1, letterSpacing: '-0.02em' }}>
                          {isAnnual ? '$197' : '$19'}<span style={{ fontSize: '14px', fontWeight: 500, color: '#A78BFA' }}>{isAnnual ? '/year' : '/mo'}</span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#FBBF24', marginTop: '6px', fontWeight: 500 }}>
                          {isAnnual ? 'Save $31/year vs monthly billing' : '7-day free trial · cancel anytime'}
                        </div>
                        <ul style={{ margin: '20px 0', padding: 0, listStyle: 'none', flex: 1, fontSize: '13px', lineHeight: 1.6, color: '#E9D5FF' }}>
                          <li style={{ padding: '4px 0' }}>Professional coaching profile in the Viveka marketplace</li>
                          <li style={{ padding: '4px 0' }}>Practice management tools — scheduling, accountability, programs, ads</li>
                          <li style={{ padding: '4px 0' }}>Monthly coaching industry insights</li>
                        </ul>
                        <button
                          type="button"
                          onClick={() => goToLoggedInCheckout('network')}
                          disabled={isCurrentNetwork}
                          style={{
                            background: isCurrentNetwork ? 'linear-gradient(135deg, #10B981 0%, #059669 100%)' : 'transparent',
                            color: '#fff',
                            border: isCurrentNetwork ? '1px solid rgba(16,185,129,0.6)' : '1px solid rgba(255,255,255,0.4)',
                            padding: '12px 20px',
                            borderRadius: '8px',
                            fontWeight: isCurrentNetwork ? 700 : 600,
                            fontSize: '14px',
                            cursor: isCurrentNetwork ? 'default' : 'pointer',
                          }}
                        >
                          {isCurrentNetwork ? '\u2713 Active subscription' : (isAnnual ? 'Subscribe Annually' : (subscription ? 'Switch to Network' : 'Start 7-Day Free Trial'))}
                        </button>
                        <div style={{ fontSize: '11px', color: isCurrentNetwork ? '#34D399' : '#A78BFA', textAlign: 'center', marginTop: '8px' }}>
                          {isCurrentNetwork
                            ? 'Manage billing in the customer portal below'
                            : ((subscription || isAnnual) ? '\u00A0' : 'No charge for 7 days. Cancel anytime.')}
                        </div>
                      </div>

                      <div
                        style={{
                          background: isCurrentLifetime ? 'rgba(16,185,129,0.10)' : 'rgba(251,191,36,0.08)',
                          border: isCurrentLifetime ? '2px solid rgba(52,211,153,0.85)' : '1px solid rgba(251,191,36,0.35)',
                          borderRadius: '14px',
                          padding: '32px 24px',
                          display: 'flex',
                          flexDirection: 'column',
                          position: 'relative',
                          marginTop: '4px',
                          boxShadow: isCurrentLifetime ? '0 0 0 4px rgba(52,211,153,0.18), 0 10px 28px rgba(16,185,129,0.20)' : 'none',
                          transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
                        }}
                      >
                        <div
                          style={{
                            position: 'absolute',
                            top: '-12px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            background: '#FBBF24',
                            color: '#1E1040',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontWeight: 700,
                            fontSize: '11px',
                            letterSpacing: '0.14em',
                            textTransform: 'uppercase',
                            padding: '5px 14px',
                            borderRadius: '999px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          Viveka First 100
                        </div>
                        {isCurrentLifetime && (
                          <div
                            style={{
                              position: 'absolute',
                              top: '-12px',
                              right: '16px',
                              background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                              color: '#fff',
                              fontFamily: "'Plus Jakarta Sans', sans-serif",
                              fontWeight: 800,
                              fontSize: '10px',
                              letterSpacing: '0.16em',
                              textTransform: 'uppercase',
                              padding: '5px 12px',
                              borderRadius: '999px',
                              whiteSpace: 'nowrap',
                              boxShadow: '0 4px 12px rgba(16,185,129,0.45)',
                            }}
                          >
                            {isCurrentInstallment ? '✓ Active — Installment Plan' : '✓ Your Active Plan'}
                          </div>
                        )}
                        <div style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.10em', textTransform: 'uppercase', color: '#FBBF24', marginBottom: '10px', marginTop: '8px' }}>
                          Verified Coach — Lifetime
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '44px', color: '#fff', lineHeight: 1, letterSpacing: '-0.02em' }}>
                          $997<span style={{ fontSize: '14px', fontWeight: 500, color: '#FBBF24', marginLeft: '8px' }}>one-time</span>
                        </div>
                        <div style={{ fontSize: '13px', color: '#FBBF24', marginTop: '8px', fontWeight: 500 }}>
                          Equivalent to $49/month today · locked in for life
                        </div>
                        <ul style={{ margin: '18px 0', padding: 0, listStyle: 'none', flex: 1, fontSize: '14px', lineHeight: 1.6, color: '#E9D5FF' }}>
                          <li style={{ padding: '4px 0' }}>Lifetime Verified Coach status — locked permanently</li>
                          <li style={{ padding: '4px 0' }}>Priority visibility across the network</li>
                          <li style={{ padding: '4px 0' }}>No renewals. No future price increases.</li>
                        </ul>
                        <button
                          type="button"
                          onClick={() => goToLoggedInCheckout('lifetime')}
                          disabled={isCurrentLifetime}
                          style={{
                            background: isCurrentLifetime ? 'linear-gradient(135deg, #10B981 0%, #059669 100%)' : '#FBBF24',
                            color: isCurrentLifetime ? '#fff' : '#1E1040',
                            border: 'none',
                            padding: '14px 24px',
                            borderRadius: '10px',
                            fontWeight: 700,
                            fontSize: '15px',
                            cursor: isCurrentLifetime ? 'default' : 'pointer',
                          }}
                        >
                          {isCurrentInstallment
                            ? '✓ Paying in installments'
                            : isCurrentLifetime
                            ? '✓ Lifetime — locked in'
                            : 'Lock In Lifetime Access'}
                        </button>
                        {lifetimeSeatsRemaining !== null && (
                          <div style={{ fontSize: '12px', color: '#A78BFA', textAlign: 'center', marginTop: '10px' }}>
                            {lifetimeSeatsRemaining} of {lifetimeSeatLimit} seats remaining
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          position: 'relative',
                          background: isCurrentVerified ? 'rgba(16,185,129,0.10)' : 'rgba(255,255,255,0.05)',
                          border: isCurrentVerified ? '2px solid rgba(52,211,153,0.85)' : '1px solid rgba(192,132,252,0.25)',
                          borderRadius: '14px',
                          padding: '28px 24px',
                          display: 'flex',
                          flexDirection: 'column',
                          boxShadow: isCurrentVerified ? '0 0 0 4px rgba(52,211,153,0.18), 0 10px 28px rgba(16,185,129,0.20)' : 'none',
                          transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
                        }}
                      >
                        {isCurrentVerified && (
                          <div
                            style={{
                              position: 'absolute',
                              top: '-12px',
                              right: '16px',
                              background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                              color: '#fff',
                              fontFamily: "'Plus Jakarta Sans', sans-serif",
                              fontWeight: 800,
                              fontSize: '10px',
                              letterSpacing: '0.16em',
                              textTransform: 'uppercase',
                              padding: '5px 12px',
                              borderRadius: '999px',
                              whiteSpace: 'nowrap',
                              boxShadow: '0 4px 12px rgba(16,185,129,0.45)',
                            }}
                          >
                            ✓ Your Active Plan
                          </div>
                        )}
                        <div style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.10em', textTransform: 'uppercase', color: '#C084FC', marginBottom: '12px' }}>
                          {isAnnual ? 'Verified Coach — Annual' : 'Verified Coach — Monthly'}
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '34px', color: '#fff', lineHeight: 1, letterSpacing: '-0.02em' }}>
                          {isAnnual ? '$497' : '$49'}<span style={{ fontSize: '14px', fontWeight: 500, color: '#A78BFA' }}>{isAnnual ? '/year' : '/mo'}</span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#FBBF24', marginTop: '6px', fontWeight: 500 }}>
                          {isAnnual ? 'Save $91/year vs monthly billing' : '7-day free trial · cancel anytime'}
                        </div>
                        <ul style={{ margin: '20px 0', padding: 0, listStyle: 'none', flex: 1, fontSize: '13px', lineHeight: 1.6, color: '#E9D5FF' }}>
                          <li style={{ padding: '4px 0' }}>Viveka Verification badge with priority placement on Marketplace Ads</li>
                          <li style={{ padding: '4px 0' }}>Eligibility for enterprise engagements and Viveka spotlight features</li>
                          <li style={{ padding: '4px 0' }}>Reporting and analytics, file uploads, and 10 active listings</li>
                        </ul>
                        <button
                          type="button"
                          onClick={() => goToLoggedInCheckout('verified')}
                          disabled={isCurrentVerified}
                          style={{
                            background: isCurrentVerified ? 'linear-gradient(135deg, #10B981 0%, #059669 100%)' : 'transparent',
                            color: '#fff',
                            border: isCurrentVerified ? '1px solid rgba(16,185,129,0.6)' : '1px solid rgba(255,255,255,0.4)',
                            padding: '12px 20px',
                            borderRadius: '8px',
                            fontWeight: isCurrentVerified ? 700 : 600,
                            fontSize: '14px',
                            cursor: isCurrentVerified ? 'default' : 'pointer',
                          }}
                        >
                          {isCurrentVerified ? '✓ Active subscription' : (isAnnual ? 'Subscribe Annually' : (subscription ? 'Switch to Verified' : 'Start 7-Day Free Trial'))}
                        </button>
                        <div style={{ fontSize: '11px', color: '#A78BFA', textAlign: 'center', marginTop: '8px' }}>
                          {(subscription || isAnnual) ? '\u00A0' : 'No charge for 7 days. Cancel anytime.'}
                        </div>
                      </div>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '24px', fontSize: '12px', color: '#A78BFA', lineHeight: 1.5 }}>
                      Lifetime is reserved for the first 100 early members. Monthly and annual remain available at standard pricing.
                    </div>

                    {/* Comparison table — full feature breakdown for eligible coaches */}
                    <div style={{ marginTop: '36px', paddingTop: '32px', borderTop: '1px solid rgba(192,132,252,0.18)' }}>
                      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 700, fontSize: '11px', letterSpacing: '0.16em', textTransform: 'uppercase', color: '#FBBF24', marginBottom: '8px' }}>
                          Full Comparison
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '20px', color: '#fff', letterSpacing: '-0.01em' }}>
                          What's included in each plan
                        </div>
                      </div>
                      <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(192,132,252,0.18)', borderRadius: '12px', overflow: 'hidden', fontSize: '13px', color: '#E9D5FF' }}>
                          <thead>
                            <tr style={{ background: 'rgba(255,255,255,0.04)' }}>
                              <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#A78BFA' }}>Feature</th>
                              <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: 700, fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#C084FC' }}>Network</th>
                              <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: 700, fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#C084FC' }}>Verified</th>
                              <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: 700, fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#FBBF24' }}>Lifetime</th>
                            </tr>
                          </thead>
                          <tbody>
                            {[
                              ['Professional marketplace profile', true, true, true],
                              ['Resource library and community', true, true, true],
                              ['Scheduling and booking', true, true, true],
                              ['Accountability tracker', true, true, true],
                              ['Program management', true, true, true],
                              ['Marketplace Ads', true, true, true],
                              ['Active listings', '3', '10', '10'],
                              ['Monthly coaching industry insights', true, true, true],
                              ['Viveka Verification badge', false, true, true],
                              ['Priority search placement', false, true, true],
                              ['File uploads', false, true, true],
                              ['Reporting and analytics', false, true, true],
                              ['Enterprise client opportunities', false, true, true],
                              ['Viveka spotlight features', false, true, true],
                              ['Lifetime status (no renewals)', false, false, true],
                              ['Locked-in price (no future increases)', false, false, true],
                            ].map(function(row, i) {
                              var renderCell = function(v, isLifetimeCol) {
                                if (v === true) return <span style={{ color: isLifetimeCol ? '#FBBF24' : '#C084FC', fontWeight: 700 }}>{'\u2713'}</span>;
                                if (v === false) return <span style={{ color: 'rgba(255,255,255,0.25)' }}>{'\u2014'}</span>;
                                return <strong style={{ color: isLifetimeCol ? '#FBBF24' : '#C084FC' }}>{v}</strong>;
                              };
                              return (
                                <tr key={i} style={{ borderTop: '1px solid rgba(192,132,252,0.08)' }}>
                                  <td style={{ padding: '12px 16px', color: '#E9D5FF' }}>{row[0]}</td>
                                  <td style={{ padding: '12px 16px', textAlign: 'center' }}>{renderCell(row[1], false)}</td>
                                  <td style={{ padding: '12px 16px', textAlign: 'center' }}>{renderCell(row[2], false)}</td>
                                  <td style={{ padding: '12px 16px', textAlign: 'center' }}>{renderCell(row[3], true)}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ) : (
                  /*
                    ── Standard pricing panel ──────────────────────
                    Coaches who signed up on or after May 1, 2026 see
                    the current ongoing pricing. Network $19/mo or
                    $197/year ($31 saved); Verified $49/mo or $497/year
                    ($91 saved). Lifetime is reserved for Viveka First
                    100 (eligible coaches only) and is not offered here.
                  */
                  <div style={{
                    marginTop: '8px',
                    padding: '36px 32px',
                    borderRadius: '20px',
                    background: '#fff',
                    border: '1px solid rgba(139,92,246,0.12)',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.04), 0 8px 24px rgba(88,28,135,0.04)',
                  }}>
                    {/* Header */}
                    <div style={{ textAlign: 'center', maxWidth: '560px', margin: '0 auto 24px' }}>
                      <h2 style={{
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                        fontWeight: 800,
                        fontSize: '24px',
                        color: '#1E1040',
                        margin: '0 0 10px',
                        letterSpacing: '-0.02em',
                      }}>
                        Choose your subscription
                      </h2>
                      <p style={{ fontSize: '14px', color: '#6B7280', lineHeight: 1.6, margin: 0 }}>
                        Subscribe monthly or save with annual. Cancel anytime during the trial.
                      </p>
                    </div>

                    {/* Monthly / Annual billing cycle toggle */}
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
                      <div
                        role="tablist"
                        aria-label="Billing cycle"
                        style={{
                          display: 'inline-flex',
                          background: '#F3E8FF',
                          border: '1px solid rgba(139,92,246,0.18)',
                          borderRadius: '999px',
                          padding: '4px',
                        }}
                      >
                        <button
                          type="button"
                          role="tab"
                          aria-selected={!isAnnual}
                          onClick={() => setIsAnnual(false)}
                          style={{
                            background: !isAnnual ? '#8B5CF6' : 'transparent',
                            color: !isAnnual ? '#fff' : '#581C87',
                            border: 'none',
                            padding: '8px 22px',
                            borderRadius: '999px',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontSize: '13px',
                            fontWeight: 700,
                            letterSpacing: '0.04em',
                            cursor: 'pointer',
                            transition: 'all .2s ease',
                          }}
                        >
                          Monthly
                        </button>
                        <button
                          type="button"
                          role="tab"
                          aria-selected={isAnnual}
                          onClick={() => setIsAnnual(true)}
                          style={{
                            background: isAnnual ? '#8B5CF6' : 'transparent',
                            color: isAnnual ? '#fff' : '#581C87',
                            border: 'none',
                            padding: '8px 22px',
                            borderRadius: '999px',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontSize: '13px',
                            fontWeight: 700,
                            letterSpacing: '0.04em',
                            cursor: 'pointer',
                            transition: 'all .2s ease',
                          }}
                        >
                          Annual
                        </button>
                      </div>
                    </div>

                    {/* Cards grid */}
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))',
                      gap: '16px',
                      alignItems: 'stretch',
                      maxWidth: '720px',
                      margin: '0 auto',
                    }}>
                      {/* Network Member */}
                      <div style={{
                        position: 'relative',
                        background: isCurrentNetwork ? '#ECFDF5' : '#fff',
                        border: isCurrentNetwork ? '2px solid #10B981' : '1px solid rgba(139,92,246,0.18)',
                        borderRadius: '14px',
                        padding: '28px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: isCurrentNetwork ? '0 0 0 4px rgba(16,185,129,0.15), 0 10px 28px rgba(16,185,129,0.18)' : 'none',
                        transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
                      }}>
                        {isCurrentNetwork && (
                          <div style={{
                            position: 'absolute',
                            top: '-12px',
                            right: '16px',
                            background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                            color: '#fff',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontWeight: 800,
                            fontSize: '10px',
                            letterSpacing: '0.16em',
                            textTransform: 'uppercase',
                            padding: '5px 12px',
                            borderRadius: '999px',
                            whiteSpace: 'nowrap',
                            boxShadow: '0 4px 12px rgba(16,185,129,0.45)',
                          }}>
                            ✓ Your Active Plan
                          </div>
                        )}
                        <div style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.10em', textTransform: 'uppercase', color: '#8B5CF6', marginBottom: '12px' }}>
                          Network Member
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '34px', color: '#1E1040', lineHeight: 1, letterSpacing: '-0.02em' }}>
                          {isAnnual ? '$197' : '$19'}<span style={{ fontSize: '14px', fontWeight: 500, color: '#6B7280' }}>{isAnnual ? '/year' : '/mo'}</span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#8B5CF6', marginTop: '6px', fontWeight: 500 }}>
                          {isAnnual ? 'Save $31/year vs monthly' : '7-day free trial'}
                        </div>
                        <ul style={{ margin: '20px 0', padding: 0, listStyle: 'none', flex: 1, fontSize: '13px', lineHeight: 1.6, color: '#374151' }}>
                          <li style={{ padding: '4px 0' }}>Professional coaching profile in the Viveka marketplace</li>
                          <li style={{ padding: '4px 0' }}>Visibility to individuals and organizations seeking coaching</li>
                          <li style={{ padding: '4px 0' }}>Invitations to Viveka hosted events and webinars</li>
                        </ul>
                        <button
                          type="button"
                          onClick={() => goToLoggedInCheckout('network')}
                          disabled={isCurrentNetwork}
                          style={{
                            background: isCurrentNetwork ? 'linear-gradient(135deg, #10B981 0%, #059669 100%)' : 'transparent',
                            color: isCurrentNetwork ? '#fff' : '#581C87',
                            border: isCurrentNetwork ? '1px solid rgba(16,185,129,0.6)' : '1px solid rgba(139,92,246,0.4)',
                            padding: '12px 20px',
                            borderRadius: '8px',
                            fontWeight: isCurrentNetwork ? 700 : 600,
                            fontSize: '14px',
                            cursor: isCurrentNetwork ? 'default' : 'pointer',
                          }}
                        >
                          {isCurrentNetwork ? '✓ Active subscription' : (isAnnual ? 'Subscribe Annually' : (subscription ? 'Switch to Network' : 'Start 7-Day Free Trial'))}
                        </button>
                      </div>

                      {/* Verified Coach (featured) */}
                      <div style={{
                        background: isCurrentVerified ? '#ECFDF5' : 'linear-gradient(180deg, #FAF5FF 0%, #fff 100%)',
                        border: isCurrentVerified ? '2px solid #10B981' : '1px solid #8B5CF6',
                        borderRadius: '14px',
                        padding: '32px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        boxShadow: isCurrentVerified ? '0 0 0 4px rgba(16,185,129,0.15), 0 10px 28px rgba(16,185,129,0.20)' : '0 8px 24px rgba(139,92,246,0.12)',
                        transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
                      }}>
                        <div style={{
                          position: 'absolute',
                          top: '-12px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)',
                          color: '#fff',
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                          fontWeight: 700,
                          fontSize: '11px',
                          letterSpacing: '0.14em',
                          textTransform: 'uppercase',
                          padding: '5px 14px',
                          borderRadius: '999px',
                          whiteSpace: 'nowrap',
                        }}>
                          Most Active Coaches
                        </div>
                        {isCurrentVerified && (
                          <div style={{
                            position: 'absolute',
                            top: '-12px',
                            right: '16px',
                            background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                            color: '#fff',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontWeight: 800,
                            fontSize: '10px',
                            letterSpacing: '0.16em',
                            textTransform: 'uppercase',
                            padding: '5px 12px',
                            borderRadius: '999px',
                            whiteSpace: 'nowrap',
                            boxShadow: '0 4px 12px rgba(16,185,129,0.45)',
                          }}>
                            ✓ Your Active Plan
                          </div>
                        )}
                        <div style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.10em', textTransform: 'uppercase', color: '#8B5CF6', marginBottom: '10px', marginTop: '8px' }}>
                          {isAnnual ? 'Verified Coach — Annual' : 'Verified Coach — Monthly'}
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '34px', color: '#1E1040', lineHeight: 1, letterSpacing: '-0.02em' }}>
                          {isAnnual ? '$497' : '$49'}<span style={{ fontSize: '14px', fontWeight: 500, color: '#6B7280' }}>{isAnnual ? '/year' : '/mo'}</span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#8B5CF6', marginTop: '6px', fontWeight: 500 }}>
                          {isAnnual ? 'Save $91/year vs monthly' : '7-day free trial'}
                        </div>
                        <ul style={{ margin: '20px 0', padding: 0, listStyle: 'none', flex: 1, fontSize: '13px', lineHeight: 1.6, color: '#374151' }}>
                          <li style={{ padding: '4px 0' }}>Viveka Verification badge with priority placement on Marketplace Ads</li>
                          <li style={{ padding: '4px 0' }}>Eligibility for enterprise coaching engagements</li>
                          <li style={{ padding: '4px 0' }}>Featured in Viveka spotlight opportunities</li>
                        </ul>
                        <button
                          type="button"
                          onClick={() => goToLoggedInCheckout('verified')}
                          disabled={isCurrentVerified}
                          style={{
                            background: isCurrentVerified ? 'linear-gradient(135deg, #10B981 0%, #059669 100%)' : 'linear-gradient(135deg, #8B5CF6, #7C3AED)',
                            color: '#fff',
                            border: 'none',
                            padding: '14px 24px',
                            borderRadius: '10px',
                            fontWeight: 700,
                            fontSize: '14px',
                            cursor: isCurrentVerified ? 'default' : 'pointer',
                            boxShadow: isCurrentVerified ? '0 4px 12px rgba(16,185,129,0.3)' : '0 4px 12px rgba(139,92,246,0.3)',
                          }}
                        >
                          {isCurrentVerified ? '✓ Active subscription' : (isAnnual ? 'Subscribe Annually' : (subscription ? 'Switch to Verified' : 'Apply for Verification'))}
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {subscriptionDetails && subscriptionDetails.subscription === 2 && (
                  <div className={css.subscriptionDetails}>
                    <div className={css.subscriptionName}>
                      <div className={css.subscriptionTitle}>Current Subscription</div>
                      <div>{getSubscriptionName(getSubscriptionType())}</div>
                    </div>

                    {!subscriptionCancellation ? (
                      <div className={css.subscriptionAction}>
                        <ReactTooltip
                          className={css.tooltip}
                          place={'right'}
                          effect={'solid'}
                          delayHide={10}
                        />
                        <FontAwesomeIcon
                          data-tip="This will schedule a cancellation of the subscription to trigger on the term end and your coupon will be removed as well"
                          className={css.hintIcon}
                          icon={faQuestionCircle}
                        />
                        <div
                          onClick={() => onRemoveButtonClick()}
                          className={css.subscriptionRemoveButton}
                        >
                          Cancel
                        </div>
                      </div>
                    ) : (
                      <p>Subscription will be cancelled on the term end</p>
                    )}
                  </div>
                )}

                <div className={css.settingsBlock}>
                  <div className={css.blockHeader}>
                    <p className={css.blockTitle}>
                      <span className={css.blockIcon}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M9 12l2 2 4-4"/>
                          <path d="M21 12c0 1.2-.504 2.4-1.35 3.3l.63 3.6-3.3-1.35A8.96 8.96 0 0112 21a9 9 0 110-18 9 9 0 019 9z"/>
                        </svg>
                      </span>
                      Plan Features
                    </p>
                  </div>
                  <div className={css.blockBody}>
                    <PaymentTable3 />
                  </div>
                </div>
              </div>
            </SettingsLayoutWrapper>
          ) : (
            <SettingsLayoutWrapper page="withdrawal">
              <div className={css.outerbase}>

                {/* ── Stripe status card ── */}
                {stripeConnected && (
                  <div className={css.settingsBlock}>
                    <div className={css.blockHeader}>
                      <p className={css.blockTitle}>
                        <span className={css.blockIcon}>
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                        </span>
                        Stripe Account Connected
                      </p>
                    </div>
                    <div className={css.blockBody}>
                      {stripeConnected && (showVerificationError || showVerificationNeeded) ? (
                        <StripeConnectAccountStatusBox
                          type={showVerificationError ? 'verificationError' : 'verificationNeeded'}
                          inProgress={getAccountLinkInProgress}
                          onGetStripeConnectAccountLink={handleGetStripeConnectAccountLink(
                            'custom_account_verification'
                          )}
                        />
                      ) : stripeConnected && savedCountry ? (
                        <StripeConnectAccountStatusBox
                          type="verificationSuccess"
                          inProgress={getAccountLinkInProgress}
                          disabled={payoutDetailsSaveInProgress}
                          onGetStripeConnectAccountLink={handleGetStripeConnectAccountLink(
                            'custom_account_update'
                          )}
                        />
                      ) : null}
                    </div>
                  </div>
                )}

                {/* ── Bank account details card ── */}
                <div className={css.settingsBlock}>
                  <div className={css.blockHeader}>
                    <p className={css.blockTitle}>
                      <span className={css.blockIcon}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <rect x="2" y="5" width="20" height="14" rx="2"/>
                          <line x1="2" y1="10" x2="22" y2="10"/>
                        </svg>
                      </span>
                      Bank Account
                    </p>
                  </div>
                  <div className={css.blockBody}>
                    <p className={css.introText}>
                      To receive payments from clients, connect your bank account via Stripe.
                      Your customers can pay by credit card — funds are transferred directly to your bank.
                    </p>

                    {!currentUserLoaded ? (
                      <p style={{ color: '#9CA3AF', fontSize: '14px' }}>
                        <FormattedMessage id="StripePayoutPage.loadingData" />
                      </p>
                    ) : (
                      <>
                        {!stripeConnected && (
                          <div className={css.warningBanner} data-testid="stripe-payout-legacy-warning">
                            <div className={css.warningBannerIcon}>
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                                <line x1="12" y1="9" x2="12" y2="13"/>
                                <line x1="12" y1="17" x2="12.01" y2="17"/>
                              </svg>
                            </div>
                            <div className={css.warningBannerContent}>
                              <p className={css.warningBannerTitle}>
                                Setting up payouts &mdash; here&apos;s what to expect
                              </p>
                              <p className={css.warningBannerText}>
                                If you had Stripe connected to Viveka before May 2025, you&apos;ll
                                need to set it up again here. We moved to a new payments
                                infrastructure, so Stripe treats this as a new account and has to
                                verify you again. We know that&apos;s annoying &mdash; sorry.
                              </p>
                              <p className={css.warningBannerText} style={{ marginBottom: 0 }}>
                                Stripe processes your payouts and, by US and EU law (IRS &sect;6050W
                                and the Bank Secrecy Act), must verify your identity before sending
                                money. After you enter your bank details below, Stripe will ask you
                                for: your government ID, your Tax ID (SSN for US individuals, EIN
                                for companies, VAT/Steuernummer in the EU), and a phone for an SMS
                                code. Total time: about 10 minutes. Viveka never sees your SSN or
                                ID document &mdash; those go directly to Stripe. Stuck?{' '}
                                <a href="mailto:support@viveka.world" className={css.warningBannerLink}>
                                  Email support
                                </a>
                                .
                              </p>
                            </div>
                          </div>
                        )}

                        <StripeConnectAccountForm
                          disabled={formDisabled}
                          inProgress={payoutDetailsSaveInProgress}
                          ready={payoutDetailsSaved}
                          stripeBankAccountLastDigits={getBankAccountLast4Digits(stripeAccountData)}
                          savedCountry={savedCountry}
                          submitButtonText={intl.formatMessage({
                            id: 'StripePayoutPage.submitButtonText',
                          })}
                          stripeAccountError={
                            createStripeAccountError ||
                            updateStripeAccountError ||
                            fetchStripeAccountError
                          }
                          stripeAccountFetched={stripeAccountFetched}
                          onChange={onPayoutDetailsFormChange}
                          onSubmit={onPayoutDetailsFormSubmit}
                          onGetStripeConnectAccountLink={handleGetStripeConnectAccountLink}
                          stripeConnected={stripeConnected}
                        />
                      </>
                    )}
                  </div>
                </div>

              </div>
            </SettingsLayoutWrapper>
          )}
        </div>
      </MainDashboardWrapper>
    </PageWrapper>
  );
};

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

StripePayoutPageComponent.defaultProps = {
  currentUser: null,
  createStripeAccountError: null,
  updateStripeAccountError: null,
  fetchStripeAccountError: null,
  stripeAccount: null,
  params: {
    returnURLType: null,
    tab: 'pricing',
  },
};

StripePayoutPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  scrollingDisabled: bool.isRequired,
  getAccountLinkInProgress: bool.isRequired,
  payoutDetailsSaveInProgress: bool.isRequired,
  createStripeAccountError: propTypes.error,
  updateStripeAccountError: propTypes.error,
  fetchStripeAccountError: propTypes.error,
  stripeAccount: propTypes.stripeAccount,
  payoutDetailsSaved: bool.isRequired,
  onPayoutDetailsFormChange: func.isRequired,
  onPayoutDetailsFormSubmit: func.isRequired,
  onGetStripeConnectAccountLink: func.isRequired,
  params: shape({
    returnURLType: oneOf(STRIPE_ONBOARDING_RETURN_URL_TYPES),
    tab: string.isRequired,
  }),
  callSetInitialValues: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const {
    getAccountLinkInProgress,
    createStripeAccountError,
    updateStripeAccountError,
    fetchStripeAccountError,
    stripeAccount,
    stripeAccountFetched,
  } = state.stripeConnectAccount;
  const { currentUser } = state.user;
  const { payoutDetailsSaveInProgress, payoutDetailsSaved } = state.StripePayoutPage;
  return {
    currentUser,
    getAccountLinkInProgress,
    createStripeAccountError,
    updateStripeAccountError,
    fetchStripeAccountError,
    stripeAccount,
    stripeAccountFetched,
    payoutDetailsSaveInProgress,
    payoutDetailsSaved,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onPayoutDetailsFormChange: () => dispatch(stripeAccountClearError()),
  onPayoutDetailsFormSubmit: (values, isUpdateCall) =>
    dispatch(savePayoutDetails(values, isUpdateCall)),
  onGetStripeConnectAccountLink: params => dispatch(getStripeConnectAccountLink(params)),
  callSetInitialValues: (setInitialValues, values) => dispatch(setInitialValues(values)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onFetchCurrentUser: () => dispatch(fetchCurrentUser()),
  onRemoveSubscription: () => dispatch(removeSubscription()),
  onReactivateSubscription: () => dispatch(reactivateSubscription()),
  onCheckProfileCompleted: () => dispatch(checkProfileCompleted()),
  onFetchPortalSession: () => dispatch(fetchPortalSession()),
});

const StripePayoutPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(StripePayoutPageComponent);

StripePayoutPage.loadData = loadData;

export default withRouter(StripePayoutPage);
